import Client from "./clients/rest";
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

export default {
    get() {
        return Client.get("/meta/lookups");
    }
};

